import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const PrivacyPolicy = () => <PublicStaticPage pageKey="privacy" />;

export default PrivacyPolicy;
